import Hosts from '../../../../Hosts';

const object_type = '/intranet/quality/attribute'
const object_type2 = '/intranet/quality/attribute/next'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/type/${companycode}/acompanhamento_type`
const api_list_order = (companycode) => `${Hosts.SIMCore_API}/${object_type2}/${companycode}/order`

const base_endpoint = '/intranet_quality_acompanhamento_type'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        name: [],
        tag: '',
        image: {},
        color: {
            primary: '',
            primary_rgb: '',
            secondary: '',
        },
        order: 0,
        type: 'acompanhamento_type',
        companycode: '',
        active: false,
        avaiable: false
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
    api_list_order,
}
